/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { trackModelPagedResultSchema } from "../trackModelPagedResultSchema.ts";
import { trackTypeEnumSchema } from "../trackTypeEnumSchema.ts";
import { trackUploadStatusSchema } from "../trackUploadStatusSchema.ts";
import { z } from "zod";

export const getApiTracksQueryParamsSchema = z.object({
    "GenreIds": z.array(z.coerce.number().int()).describe("Фильтр по жанрам").optional(),
"MoodIds": z.array(z.coerce.number().int()).describe("Идентификаторы тегов настроения").optional(),
"Types": z.array(z.lazy(() => trackTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыка</li>\n<li><b>2 - Podcast</b>: Подкаст</li>\n<li><b>3 - Sermon</b>: Проповедь</li>\n<li><b>4 - Book</b>: Аудиокнига</li>\n<li><b>5 - Jingle</b>: Джингл</li>\n</ul>\n")).describe("Фильтр по типу трека").optional(),
"AlbumIds": z.array(z.string().uuid()).describe("Фильтр по альбомам").optional(),
"JingleCollectionIds": z.array(z.string().uuid()).describe("Фильтр по подборкам джинглов").optional(),
"ExcludeJingleCollectionIds": z.array(z.string().uuid()).describe("Фильтр-исключение по подборкам джинглов").optional(),
"AuthorIds": z.array(z.string().uuid()).describe("Фильтр по авторам").optional(),
"ExcludedAlbumIds": z.array(z.string().uuid()).describe("Фильтр: исключение альбомов (получение треков, не принадлежащих указанным альбомам)").optional(),
"ExcludedAuthorIds": z.array(z.string().uuid()).describe("Фильтр: исключение авторов (получение треков, не принадлежащих указанным авторам)").optional(),
"TrackIds": z.array(z.string().uuid()).describe("Фильтр по идентификаторам треков").optional(),
"HasAlbum": z.boolean().describe("Флаг: принадлежит ли трек альбому.\r\nПередать false, если необходимо получить треки без привязки к альбому").optional(),
"UploadStatuses": z.array(z.lazy(() => trackUploadStatusSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>0 - Uploaded</b>: Загружен</li>\n<li><b>1 - Uploading</b>: В процессе загрузки</li>\n<li><b>2 - DeletionPending</b>: В процессе удаления</li>\n</ul>\n")).describe("Статусы загрузки").optional(),
"SortByName": z.boolean().describe("Сортировать по наименованию").optional(),
"SortByNameDesc": z.boolean().describe("Сортировать по наименованию с конца").optional(),
"SortByAuthor": z.boolean().describe("Сортировать по основному автору").optional(),
"SortByAuthorDesc": z.boolean().describe("Сортировать по основному автору с конца").optional(),
"SortByAlbum": z.boolean().describe("Сортировать по наименованию альбома").optional(),
"SortByAlbumDesc": z.boolean().describe("Сортировать по наименованию альбома с конца").optional(),
"IsArchive": z.boolean().describe("Флаг архивности (null - получить все, false - получить неархивные, true - получить архивные)").optional(),
"SearchQuery": z.string().describe("Строка поиска").optional(),
"Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Список треков
 */
export const getApiTracks200Schema = z.lazy(() => trackModelPagedResultSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiTracks400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiTracks401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiTracks403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiTracks500Schema = z.lazy(() => badResponseModelSchema)

export const getApiTracksQueryResponseSchema = z.lazy(() => getApiTracks200Schema)